import React from 'react'
import { PencilRuler, Laptop, TabletSmartphone, Network, MonitorCog } from 'lucide-react'

function Services() {
    return (
        <div className="p-3 relative w-full rounded-lg">
            <div className='flex items-center gap-2 relative'>
                <PencilRuler className='w-5 h-5 text-blue-500' />
                <h1 className='text-lg font-bold'>Services</h1>
            </div>
            <p className='text-sm text-gray-300'>My services are tailored to your needs and budget</p>
            <div className="grid grid-cols-2 gap-8 mt-5">
                <Card
                    icon={<Laptop className='w-6 h-6 text-white -rotate-90' />}
                    title="Web Development"
                    description="I create responsive and user-friendly websites."
                />
                <Card
                    icon={<TabletSmartphone className='w-6 h-6 text-white -rotate-90' />}
                    title="Mobile Development"
                    description="I build mobile apps for iOS and Android using Flutter."
                />
                <Card
                    icon={<Network className='w-6 h-6 text-white -rotate-90' />}
                    title="Deployment & Hosting"
                    description="I handle deployment and hosting for your website or app."
                />
                <Card
                    icon={<MonitorCog className='w-6 h-6 text-white -rotate-90' />}
                    title="Custom Web Applications"
                    description="I develop web solutions to meet your needs."
                />
            </div>
        </div>
    )
}

const Card = ({icon, title, description}) => {
    return (
        <div className='flex flex-col gap-1 items-center justify-center'>
            <div className='mb-2 w-14 h-12 bg-blue-500 rotate-90 flex justify-center items-center' style={{clipPath: "polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)"}}>
                {icon}
            </div>
            <h1 className='font-semibold text-center text-sm md:text-md lg:text-md xl:text-md'>{title}</h1>
            <p className='text-center text-xs md:text-sm lg:text-sm xl:text-sm text-gray-300'>{description}</p>
        </div>
    );
}

export default Services